"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
var _noop = _interopRequireDefault(require("lodash/noop"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var UserWorksheetStore = /*#__PURE__*/function (_RootStore) {
  function UserWorksheetStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, UserWorksheetStore);
    _this = _callSuper(this, UserWorksheetStore);
    _this.config = {
      model: _models.UserWorksheet,
      deserialize: true,
      GET: {
        index: '/groups/:groupId/user_worksheets',
        show: '/user_worksheets/:userWorksheetId'
      },
      PUT: {
        update: 'user_worksheets/:userWorksheetId',
        updateByWorksheetId: 'user_worksheets/:worksheetId/update_by_worksheet_id'
      },
      POST: {
        create: 'user_worksheets'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(UserWorksheetStore, _RootStore);
  return (0, _createClass2["default"])(UserWorksheetStore, [{
    key: "updateByWorksheetId",
    value: function updateByWorksheetId(params) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _noop["default"];
      this.api(params, callback, 'PUT', 'updateByWorksheetId');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new UserWorksheetStore();